import React from 'react'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import { type CSSVariableColor } from '@repo/ui/types/colors'
import { cn } from '@repo/ui/lib'
import { useLocale } from 'next-intl'

export type InputCurrency = 'IRR' | 'TMN' | 'MALEK' | 'JIRNAL' | 'm2' | 'crypto'
export type OutputCurrency = 'IRR' | 'TMN' | 'MALEK' | 'JIRNAL'
interface PaymentTypeProps {
  value?: string | number
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'xl' | '2xl' | '3xl'
  numberSize?: '2xs' | 'xs' | 'sm' | 'md' | 'xl' | '2xl' | '3xl'
  numberColor?: CSSVariableColor | undefined
  color?: CSSVariableColor | undefined
  approximately?: boolean
  isBold?: boolean
  inputCurrency?: InputCurrency
  outputCurrency?: OutputCurrency
  hideValue?: boolean
  showExactCurrency?: boolean
  hideCurrency?: boolean
  className?: string
}

export const PaymentType = (props: PaymentTypeProps) => {
  const {
    value,
    size = 'sm',
    numberSize = 'sm',
    numberColor = 'text-neutral-surface-100',
    color = 'text-neutral-surface-80',
    approximately = false,
    isBold = true,
    inputCurrency = 'IRR',
    outputCurrency = 'TMN',
    hideValue = false,
    hideCurrency = false,
    showExactCurrency = false,
    className,
  } = props
  const { tRich } = useTranslate()
  const locale = useLocale()

  const langs = {
    fa: 'fa-IR',
    en: 'en-US',
  }

  const lang = langs[locale as keyof typeof langs]

  return !value && value !== 0 ? (
    <Typography
      variant='span'
      size={size}
      weight='regular'
      color={color}
      className={cn('whitespace-nowrap', className)}
    >
      -
    </Typography>
  ) : (
    <Typography
      variant='span'
      size={size}
      weight='regular'
      color={color}
      className={cn('whitespace-nowrap', className)}
    >
      {inputCurrency === 'crypto' &&
        tRich.rich(hideCurrency ? 'common_value' : 'common_token2', {
          value: () => (
            <Typography
              variant='bdi'
              size={numberSize}
              weight={isBold ? 'bold' : 'regular'}
              color={numberColor}
              className='px-3xs'
            >
              {hideValue
                ? '*****'
                : Math.floor(+value).toLocaleString(lang, {
                    maximumFractionDigits: 0,
                  })}
            </Typography>
          ),
        })}
      {inputCurrency === 'IRR' &&
        tRich.rich(hideCurrency ? 'common_value' : 'common_toman', {
          value: () => (
            <Typography
              variant='bdi'
              size={numberSize}
              weight={isBold ? 'bold' : 'regular'}
              color={numberColor}
            >
              {hideValue
                ? '*****'
                : inputCurrency === 'IRR' && outputCurrency === 'TMN'
                  ? Math.floor(+value / 10).toLocaleString(lang, {
                      maximumFractionDigits: 0,
                    })
                  : Math.floor(+value).toLocaleString(lang, {
                      maximumFractionDigits: 0,
                    })}

              {approximately ? '~' : ''}
            </Typography>
          ),
        })}
      {inputCurrency === 'MALEK' &&
        tRich.rich(showExactCurrency ? 'common_malek_exact' : 'common_malek', {
          value: () => (
            <Typography
              variant='bdi'
              size={numberSize}
              weight={isBold ? 'bold' : 'regular'}
              color={numberColor}
              className='px-3xs'
            >
              {hideValue
                ? '*****'
                : Math.floor(+value).toLocaleString(lang, {
                    maximumFractionDigits: 0,
                  })}
            </Typography>
          ),
        })}
      {inputCurrency === 'm2' &&
        tRich.rich('common_meter_square', {
          value: () => (
            <Typography
              variant='bdi'
              size={numberSize}
              weight={isBold ? 'bold' : 'regular'}
              color={numberColor}
            >
              {hideValue
                ? '*****'
                : Math.floor(+value).toLocaleString(lang, {
                    maximumFractionDigits: 0,
                  })}
            </Typography>
          ),
        })}
    </Typography>
  )
}
